import { Currencies, CurrencyType } from '@/entities/curency'
import { WeekDays } from '@/entities/farm'
import { NewPaymentRequisiteModel, PaymentRequisiteModel } from '@/entities/paymentRequisit'

export enum RequisiteStatuses {
  Active = 1,
  Disabled = 2,
  Blocked = 3,
}

export type NewRequisite = {
  farmId: string | null
  currency: CurrencyType
  maxDailyLimit: number | null
  maxMonthlyLimit: number | null
  maxDailyTopupsCounter: number | null
  maxMonthlyTopupsCounter: number | null
  minTimeoutBetweenDealsInMinutes: number | null
  minDealAmount: number | null
  maxDealAmount: number | null
  dayOfWeek: WeekDays | null
  workHoursStartsAt: string | null
  workHoursEndsAt: string | null
  sbpPaymentLink: string | null
  deviceId: string
  bankId: string
  personName: string | null
  personSurname: string | null
  personMiddlename: string | null
  createPaymentRequisitRequests: NewPaymentRequisiteModel[]
}

export type UpdateRequisite = {
  farmId: string | null
  currency: CurrencyType
  maxDailyLimit: number | null
  maxMonthlyLimit: number | null
  maxDailyTopupsCounter: number | null
  maxMonthlyTopupsCounter: number | null
  minTimeoutBetweenDealsInMinutes: number | null
  minDealAmount: number | null
  maxDealAmount: number | null
  dayOfWeek: WeekDays | null
  workHoursStartsAt: string | null
  workHoursEndsAt: string | null
  sbpPaymentLink: string | null
  id: string
  paymentRequisitProfiles: PaymentRequisiteModel[] | null,
}

export type FilterRequisite = {
  requisitStatus: number
  textFilter: string
  skip: number
  take: number
}

export type RequisiteModel = {
  id: string
  createdAt: string
  lastModifiedAt: string | null
  isDeleted: boolean | null
  deletedAt: string | null
  isBlocked: boolean | null
  blockedAt: string | null
  blockedReason: string | null
  isDisabledByUser: boolean | null
  disabledAt: string | null
  userId: string
  deviceId: string
  bankId: string
  farmId: string | null
  personName: string | null
  personSurname: string | null
  personMiddlename: string | null
  country: string | null
  currency: Currencies
  maxDailyLimit: number | null
  maxMonthlyLimit: number | null
  maxDailyTopupsCounter: number | null
  maxMonthlyTopupsCounter: number | null
  minTimeoutBetweenDealsInMinutes: number | null
  minDealAmount: number | null
  maxDealAmount: number | null
  dayOfWeek: number | null
  workHoursStartsAt: string | null
  workHoursEndsAt: string | null
  sbpPaymentLink: string | null
  priority: number
  paymentRequisitProfiles: PaymentRequisiteModel[] | null
  requisitStatus: RequisiteStatuses
}

export enum UpdateRequisitesStatus {
  Enable = 1,
  Disable = 2,
  Block = 3,
}

export type EnrichedRequisiteModel = RequisiteModel & {
  dailyTotal: number
  allDealsTotal: number
  successfulDealsTotal: number
}

export type PaymentMethodLimitRow = {
  id?: string
  method: string;
  limit: number;
}
